import { jsx as o } from "react/jsx-runtime";
import i from "./index.es5436.js";
import { RankingBar as a } from "./index.es136.js";
const n = ({ testId: r, ...t }) => /* @__PURE__ */ o("div", { "data-testid": `${r}-cell`, className: i.root, children: /* @__PURE__ */ o(a, { ...t, testId: r }) });
export {
  n as RankingCell
};
//# sourceMappingURL=index.es630.js.map
